import { Component, createEffect, createMemo, JSX, useContext } from 'solid-js'
import { unwrap } from 'solid-js/store'
import type { Nullable } from 'vite-node'
import EngineContext from '../../../components/EngineContext'
import { createCanvasElement, createOffscreenCanvas } from '../../canvas/create_canvas'
import { getCanvas2dContext } from '../../canvas/get_canvas_2d_context'
import type { Engine } from '../../core/engine/Engine.type'
import { isEntityDesert, isEntityForest, isEntityMountain, isEntityPlain, isEntityShoal, isEntitySnow } from '../../core/entity/entityTypeMetaList.generated'
import getEntityXYGridMap from '../../core/entity/EntityXYGridMap/getEntityXYGridMap'
import type { Entity } from '../../core/entity/index'
import isEntityUnit from '../../core/entity/isEntityUnit'
import isEntityWater from '../../core/entity/isEntityWater'
import isMapControlTarget from '../../core/entity/isMapControlTarget'
import { BLACK_HEX, WHITE_HEX } from '../../core/player/player_color'
import { useAuthPlayerIdSignal } from '../../../rx/signal/useAuthPlayerIdSignal'
import type { PlayerId } from '../../core/player/PlayerId'
import type { State } from '../../core/state/State.type'

interface Props {
  state: State,
  style?: JSX.CSSProperties,
  size: number,
}

const MiniMap1Px: Component<Props> = (props) => {
  // console.log('MiniMap1Px.init')

  const engine: Engine = useContext(EngineContext)
  const [getAuthPlayerId] = useAuthPlayerIdSignal(engine)
  const getState = createMemo(() => unwrap(props.state))
  const canvasElem = createCanvasElement()
  const buffer = createOffscreenCanvas(1, 1)
  // const getEntityXYGridMap = getEntityXYGridMapMemo(() => getState().ents)

  createEffect(() => {
    // console.log('MiniMap1Px.effect')
    // eslint-disable-next-line solid/reactivity
    const { size } = props
    const dpr = window.devicePixelRatio
    // const { state, authPlayerId } = engine
    const state = getState()
    const authPlayerId = getAuthPlayerId()
    const grid = getEntityXYGridMap(state.ents)
    // console.log('grid', grid)
    const { width, height } = state
    buffer.width = size * width
    buffer.height = size * height
    canvasElem.width = buffer.width
    canvasElem.height = buffer.height
    const ctx = getCanvas2dContext(buffer)
    const ctx2 = getCanvas2dContext(canvasElem)
    if (ctx && ctx2) {
      // ctx.clearRect(0, 0, buffer.width, buffer.height)
      // ctx2.clearRect(0, 0, buffer.width, buffer.height)
      for (const [xy, ents] of grid) {
        // console.log('MiniMap1Px', deepClone(xy), ents.map(entityDisplayName), deepClone(ents))
        // return
        ctx.fillStyle = getEntityPixelFillColor(ents[0], authPlayerId)
        // ctx.scale(size, size)
        ctx.fillRect(xy.x * size, xy.y * size, size, size)
      }

      ctx2.drawImage(buffer, 0, 0)
      canvasElem.style.width = `${(size * width) / dpr}px`
      canvasElem.style.height = `${(size * height) / dpr}px`
      // canvasElem.style.padding = '0px'
      // canvasElem.style.margin = '0px'
    }
  })

  return canvasElem
}

export default MiniMap1Px


const GREEN_HEX = '#0f0'
const BLUE_HEX = '#00f'
const RED_HEX = '#f00'
const GRAY_HEX = '#888'
const BROWN_HEX = '#884'
const FOREST_GREEN_HEX = '#2b520f'
const GRASS_GREEN_HEX = '#5b7'
const SNOW_WHITE_HEX = '#fff'
const DESERT_BROWN_HEX = '#844'
const SANDY_BEANCH_HEX = '#f88'

function getEntityPixelFillColor(ent: Nullable<Entity>, playerId: Nullable<PlayerId>): string {
  if (ent) {
    if (isEntityUnit(ent) || isMapControlTarget(ent)) {
      if (ent.player_id === playerId) {
        return GREEN_HEX
      }
      // TODO allied players should be blue
      // if (!ent.player_id) {
      //   return BLUE_HEX
      // }
      if (!ent.player_id) {
        return GRAY_HEX
      }
      return RED_HEX
    }
    if (isEntityMountain(ent)) {
      return BROWN_HEX
    }
    if (isEntityShoal(ent)) {
      return SANDY_BEANCH_HEX
    }
    if (isEntityWater(ent)) {
      return BLUE_HEX
    }
    if (isEntityForest(ent)) {
      return FOREST_GREEN_HEX
    }
    if (isEntityPlain(ent)) {
      return GRASS_GREEN_HEX
    }
    if (isEntitySnow(ent)) {
      return SNOW_WHITE_HEX
    }
    if (isEntityDesert(ent)) {
      return DESERT_BROWN_HEX
    }

    return WHITE_HEX
  }
  return BLACK_HEX
}